export enum CallSessionStatus {
  PROCESSING = 1,
  COMPLETED = 2
}
